import { fromJS } from 'immutable'
import {
  DEPARTMENT_GET_REQUEST,
  DEPARTMENT_GET_SUCCESS,
  DEPARTMENT_GET_FAILURE,
  DEPARTMENT_GET_RESET,
} from './../../constants'

const init = fromJS({
  isFetching: false,
  isAuthenticated: localStorage.getItem('access_token') !== null,
  redirect: false,
})

export default (state = init, action) => {
  switch (action.type) {
    case DEPARTMENT_GET_REQUEST:
      return state
        .set('isFetching', true)
    case DEPARTMENT_GET_SUCCESS:
      return state
        .set('department', fromJS(action.payload.department))
        .set('isFetching', false)
    case DEPARTMENT_GET_FAILURE:
      if (action.payload.status === 401) {
        return state
          .set('redirect', true)
      }
      return state
        .set('isFetching', false)
    case DEPARTMENT_GET_RESET:
      return state
        .delete('department')
        .set('isFetching', false)
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/department/department-get-reducer.js